import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Form } from 'antd'
import moment from 'moment'

import { AttachmentField, DatePicker, Dropdown, FormContainer } from 'Shared/Components/FormComponents'
import useFetchData from 'Shared/Hooks/useFetchData'
import { apiUrl } from 'Shared/utils'
import { showSuccess } from 'Shared/Components/NotifyToast'

const CertificateRenewForm = ({ certificate_id, certificates, assets_id, reload, closemodal }) => {
  const { t } = useTranslation()
  const { send } = useFetchData()
  const [form] = Form.useForm()
  const { setPageLoading } = useOutletContext()

  const [equipmentCertificates, setEquipmentCertificates] = useState([])

  useEffect(() => {
    const init = async () => {
      setPageLoading(true)

      setEquipmentCertificates(certificates.map((i) => ({
        "value": i["certificate_id"],
        "label": i["certificate_name"],
      })))

      setPageLoading(false)
    }

    init()
  }, [])

  const onFinish = async (value) => {
    setPageLoading(true)

    const formData = new FormData()
    formData.append('start_date', moment(new Date(value["startDate"])).format("YYYY-MM-DD"))
    formData.append('end_date', moment(new Date(value["endDate"])).format("YYYY-MM-DD"))
    formData.append('attachment', value["attachment"]["fileList"][0].originFileObj)
    
    const res = await send({
      method: "POST",
      url: `${apiUrl}/assets_tracking/equipment/${assets_id}/certificate/renew/${value["certificate"]}`,
      contentType: "formdata",
      body: formData
    })

    if (res != null) {
      showSuccess(t("general_success"))
      closemodal()
      await reload()
    }

    setPageLoading(false)
  }

  return (<>
    <FormContainer form={form} onFinish={onFinish} initialValues={{ certificate: certificate_id }}>
      <Dropdown field_name={t("assetsTracking_certificateName")} field_id="certificate" props={{ "options": equipmentCertificates }} disabled />
      <DatePicker field_name={t("assetsTracking_certificateStartDate")} field_id="startDate" required props={{ "type": "date", "max":  new Date() }} />
      <DatePicker field_name={t("assetsTracking_certificateEndDate")} field_id="endDate" required props={{ "type": "date", "min":  new Date() }} />
      <AttachmentField field_name={t("assetsTracking_certificateAttachment")} field_id="attachment" required props={{ "maxCount": 1, "multiple": false, "accept": "application/pdf" }}  />
    </FormContainer>
  </>)
}

export default CertificateRenewForm
